<template>
  <v-card
    class="mx-auto mt-10"
    max-width="500"
    flat
    elevation="0"
  >
    <v-app-bar color="secondary">
      <v-toolbar-title>Your Profiles</v-toolbar-title>
        <v-btn color="secondary" class="ma-2" fab x-small @click="openInfo">
          <v-icon>mdi-information-variant</v-icon>
        </v-btn>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="white lighten-2 black--text" rounded dark class="mb-2" v-bind="attrs" v-on="on">New Profile</v-btn>
        </template>
        <v-card>
          <v-app-bar color="secondary lighten-2">
            <v-toolbar-title>Add New Profile</v-toolbar-title>
          </v-app-bar>
          <Alert />
          <v-card-text class="mt-5">
            <v-form ref="form" v-model="valid">
              <v-text-field
                label="Firstname"
                name="login"
                prepend-icon="mdi-account"
                type="text"
                v-model="profile.firstname"
                required
                :rules="nameRules"
                rounded
                dense
                outlined
              />
              <v-text-field
                label="Surname"
                name="login"
                prepend-icon="mdi-account"
                type="text"
                v-model="profile.surname"
                required
                :rules="nameRules"
                rounded
                dense
                outlined
              />
              <v-text-field
                label="Date of birth"
                name="date_of_birth"
                prepend-icon="mdi-calendar"
                :rules="dobRules"
                v-model="profile.date_of_birth"
                type="date"
                required
                rounded
                dense
                outlined
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="green darken-1" text @click="save">Save</v-btn>
            <v-btn outlined color="buttons darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app-bar>
    <v-expansion-panels focusable>
    <v-expansion-panel
      v-for="(item,i) in profiles"
      :key="i"
    >
      <v-expansion-panel-header>
        <span class="text-h6">{{ item.firstname }}  {{ item.surname }}</span>
        <v-spacer></v-spacer>
        <v-btn rounded @click="open(item)" color="buttons" class="mr-4">Open</v-btn>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container>
          <v-row>
            <v-col cols="12" md="4" class="pt-5">
              <v-chip :color="getColor(item.subscription)" dark>{{ item.code }}</v-chip>
            </v-col>
            <v-col cols="12" md="8">
              <v-btn class="ma-2" tile outlined color="buttons" @click="cancelItem(item)">
                <v-icon left>mdi-account-cancel</v-icon>Cancel
              </v-btn>
              <v-btn class="ma-2" tile outlined color="primary" @click="deleteItem(item)">
                <v-icon left>mdi-delete</v-icon>Delete
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  <!-- Dialog -->
  <v-dialog v-model="deleteDialog" persistent max-width="390">
    <v-card>
      <v-card-title class="text-body-h6 text-center">Delete Profile</v-card-title>
      <v-card-text class="font-weight-bold">You have clicked to Delete this profile for {{ toDelete.firstname }}. <strong>Please</strong> understand that this process cannot be reversed. All the data related to this profile will be deleted from our database. Would you like to continue? </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" outlined text @click="confirmDelete"><v-icon left>mdi-thumb-up</v-icon> Yes</v-btn>
        <v-btn color="red darken-1" outlined text @click="cancelDelete"> <v-icon left>mdi-thumb-down</v-icon>Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Dialog -->
  <Information ref="info"/>
  </v-card>
</template>

<script>
//import AddProfile from "../components/forms/AddProfileComp";
//import Profiles from "../components/views/ProfilesView";
import Information from "../components/dialogs/Information";
import Alert from "@/components/templates/Alert"
import { mapGetters } from "vuex";
export default {
  name: "profiles",
  created() {
    //this.component = Profiles
    this.$store.dispatch("user/aAccountProfiles").then(response => {
      if (response) {
        this.dataProfiles = this.profiles;
      }
    });
  },
  components: { Information, Alert },
  data: () => ({
    deleteDialog: false,
    dialog: false,
    valid: true,
    toDelete: [],
    nameRules: [
      v => !!v || "This field is required",
      v => v.length >= 3 || "Minimum length is 3 characters"
    ],
    dobRules: [
      v => !! v || "The date of birth id required"
    ],
    profile: {
      firstname: "",
      surname: "",
      date_of_birth: ""
    },
    headers: [
      {
        text: "Firstname",
        align: "start",
        sortable: false,
        value: "firstname"
      },
      { text: "Surname", value: "surname" },
      { text: "Profile Number", value: "code", sortable: false },
      { text: "Actions", value: "actions", sortable: false }
    ],
    dataProfiles: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    },
    dialogMessage: {
      title: "About Profiles",
      text: [
        "Your account can have at most nine (9) profiles associated to it.",
        "A profile can belong to you and your family members and friends who are unable to manage their account"
      ]
    }
  }),
  computed: {
    ...mapGetters("user", {
      profiles: "gProfiles",
      thisProfile: "gCurrentProfile"
    })
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    getColor(subscription) {
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      if (subscription < now) {
        return 'red';
      } else {
        return 'green';
      }

    },
    open(item) {
      this.$store.dispatch("user/aSetProfile", item.id).then(res => {
        if (res) {
          this.$router.push({ name: "Profile_home" });
        } else {
          this.$router.push({ name: "Subscribe" });
        }
      });
    },

    deleteItem(item) {
      this.deleteDialog = true
      this.toDelete = item
    },
    confirmDelete() {
      this.$store.dispatch("user/aDeleteProfile", this.toDelete.id)
    },
    cancelDelete() {
      this.deleteDialog = false;
      this.toDelete = [];
    },
    cancelItem(item) {
      this.$store.dispatch("user/aCancelProfile", item.id).then(res => {
        if (res) {
          //
        }
      });
    },
    openInfo() {
      this.$refs.info.openDialog(this.dialogMessage)
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("user/aAddProfile", this.profile).then(res => {
          if (res) {
            this.dialog = false;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.add-form {
  display: none;
}
</style>
